'use client';

import { c as _c } from "react/compiler-runtime";
import { useDecisions } from '../../hooks';
import { LocalAdLegacy } from './LocalAd.legacy';
import { LocalAdV2 } from './LocalAd.v2';
type LocalAdScriptsProps = {
  onDone: () => void;
};
export const LocalAdScripts = props => {
  const $ = _c(3);
  const isOneTrust = useDecisions("onetrust");
  let t0;
  if ($[0] !== isOneTrust || $[1] !== props) {
    t0 = isOneTrust ? <LocalAdV2 {...props} /> : <LocalAdLegacy {...props} />;
    $[0] = isOneTrust;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};